import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from "@mui/material";
import { T } from "../routes/Translate";
import { brandColors } from "../theme";

// Invitación a iniciar sesión que aparece después de un rato en Explorar
// (el inicio para visitantes sin cuenta). No va de entrada: AdSense y Google
// tienen que ver el contenido, no un login. Se puede cerrar y no vuelve a
// salir en la misma sesión del navegador.
const DELAY_MS = 20000;
const STORAGE_KEY = "guestLoginPromptShown";

const alreadyShown = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

const markShown = () => {
  try {
    sessionStorage.setItem(STORAGE_KEY, "1");
  } catch {
    // sin sessionStorage (modo privado): puede volver a aparecer, no pasa nada
  }
};

const GuestLoginPrompt = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (alreadyShown()) return undefined;
    const timer = setTimeout(() => {
      markShown();
      setOpen(true);
    }, DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const close = () => setOpen(false);
  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  return (
    <Dialog open={open} onClose={close} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>
        <T>¿Ya tenés cuenta en Notiline?</T>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ color: "text.secondary" }}>
          <T>Iniciá sesión para usar cupones, comprar en tiendas, guardar publicaciones y contactar a vendedores. Crear tu cuenta es gratis.</T>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, flexWrap: "wrap", gap: 1 }}>
        <Button onClick={close} sx={{ color: "text.secondary" }}>
          <T>Seguir mirando</T>
        </Button>
        <Button variant="outlined" onClick={() => go("/register")}>
          <T>Crear cuenta</T>
        </Button>
        <Button
          variant="contained"
          onClick={() => go("/login")}
          sx={{ bgcolor: brandColors.action, fontWeight: 700 }}
        >
          <T>Iniciar sesión</T>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GuestLoginPrompt;
